<template>
    <div class="pa-5 pt-2 pb-1">
        <v-row>
            <v-col class="pa-0" cols="3">
                <v-col class="col-item row-title">{{ "Product" | t }}</v-col>
            </v-col>
            <v-col class="pb-0 pt-0">
                <v-col class="col-item row-title pl-0">{{ "Sale price" | t }}</v-col>
            </v-col>
            <v-col class="pb-0 pt-0">
                <v-col class="col-item row-title pl-0">{{ "Amount" | t }}</v-col>
            </v-col>
            <v-col class="pb-0 pt-0">
                <v-col class="col-item row-title">{{ "Sum" | t }}</v-col>
            </v-col>
            <v-col class="pb-0 pt-0">
                <v-col class="col-item row-title">{{ "Export price" | t }}</v-col>
            </v-col>
            <v-col class="pb-0 pt-0">
                <v-col class="col-item row-title">{{ "Profit" | t }}</v-col>
            </v-col>
            <v-col class="pb-0 pt-0">
                <v-col class="col-item row-title pr-2">
                    {{ "Marginal" | t }}
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" class="info-icon"> info</v-icon>
                        </template>
                        <span>{{ "From export price" | t }}</span>
                    </v-tooltip>
                </v-col>
            </v-col>
        </v-row>
        <div v-for="item in activeExportInvoice.rows" v-if="activeExportInvoice.rows" :key="item.id">
            <v-row>
                <v-col class="pa-0" cols="3">
                    <v-col class="col-item">
                        {{ item.code ? "(" + item.code + ")" : "" }}
                        {{ item.product_name ? item.product_name : "-" }}
                    </v-col>
                </v-col>

                <v-col class="pb-0 pt-0">
                    <v-col class="col-item pl-0">
                        {{ item.sale_price | rn }}
                    </v-col>
                </v-col>
                <v-col class="pb-0 pt-0">
                    <v-col class="col-item pl-0">
                        {{ item.amount | rn }}
                    </v-col>
                </v-col>
                <v-col class="pb-0 pt-0">
                    <v-col class="col-item font-weight-bold">
                        {{ item.sum | rn }}
                    </v-col>
                </v-col>
                <v-col class="pb-0 pt-0">
                    <v-col class="col-item" :class="{ 'has-no-value': !item.own_price }">
                        {{ item.own_price | rn }}
                        <span v-if="!item.own_price">!</span>
                    </v-col>
                </v-col>
                <v-col class="pb-0 pt-0">
                    <v-col class="col-item font-weight-bold">
                        {{ item.profit | rn }}
                    </v-col>
                </v-col>
                <v-col class="pb-0 pt-0">
                    <v-col class="col-item">
                        {{
                            item.profit && item.sum
                                ? (Math.round((item.profit / item.sum) * 100 * 100) / 100).toFixed(2) + "%"
                                : "-"
                        }}
                    </v-col>
                </v-col>
            </v-row>
            <v-divider class="my-2" />
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "rows-tab",
    data() {
        return {};
    },
    computed: {
        ...mapState("ExportSaleInvoiceStore", ["activeExportInvoice"])
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 2px;
    padding-bottom: 2px;
}

.has-no-value {
    color: red;
    font-weight: bold;
}

.info-icon {
    font-size: 18px;
}
</style>
